import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "grid grid-cols-4 gap-6 pb-8 mt-6" }
const _hoisted_5 = { class: "col-span-4 sm:col-span-2" }
const _hoisted_6 = { class: "relative mt-1" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-span-4 sm:col-span-1" }
const _hoisted_10 = { class: "col-span-4 sm:col-span-1" }
const _hoisted_11 = { class: "col-span-4 sm:col-span-2" }
const _hoisted_12 = { class: "relative mt-1" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "col-span-4 sm:col-span-1" }
const _hoisted_16 = { class: "col-span-4 sm:col-span-1" }
const _hoisted_17 = { class: "py-3 mt-4 text-center" }
const _hoisted_18 = { class: "mt-10" }
const _hoisted_19 = { class: "mt-6 space-y-4" }
const _hoisted_20 = { class: "px-6 py-4 border-b sm:grid md:grid-cols-8 bg-clay-50" }
const _hoisted_21 = { class: "py-2 sm:col-span-1" }
const _hoisted_22 = { class: "py-2 sm:col-span-3" }
const _hoisted_23 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_24 = { class: "text-xs text-clay-800" }
const _hoisted_25 = {
  key: 0,
  class: "text-sm text-clay-800"
}
const _hoisted_26 = { class: "py-2 text-sm font-medium sm:col-span-1" }
const _hoisted_27 = { class: "py-2 text-sm text-clay-800 sm:col-span-2" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  "aria-hidden": "true",
  class: "hidden py-2 text-right sm:col-span-1"
}
const _hoisted_30 = { class: "py-2 text-left sm:col-span-1 sm:text-right" }
const _hoisted_31 = ["onClick"]

import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import draggable from 'vuedraggable';
import {
    AddExperience,
    DeleteExperience,
    ExperienceDTO,
    GetExperiences,
    GetExperiencesResponse, SearchGuidesByCategory, SearchGuidesByCategoryResponse, ShowDto,
    SortExperiences, TheatreCompanyDTO,
    ToggleExperienceIsFeatured
} from "@/dtos";
// @ts-ignore
import {CheckIcon, ChevronDownIcon, TrashIcon, ListBulletIcon} from '@heroicons/vue/20/solid';
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SaCombobox from "@/main/components/SaCombobox.vue";
import {Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Switch} from '@headlessui/vue';
import _ from "lodash";
import {trackEvent} from '@/shared';
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateProfileCredits',
  setup(__props) {

// @ts-ignore

let responseStatus = ref(null);
let credit = ref({});
let credits: Ref<ExperienceDTO[]> = ref([]);
let updateSuccessful: Ref<Boolean> = ref(false);

let shows: Ref<ShowDto> = ref([]);
const selectedShow = ref({});
const query = ref('');

const queryShow = computed(() => {
    return query.value === '' || query.value.length < 3 ? null : {id: null, title: query.value}
});

const getShows = async (event: any) => {
    query.value = event.target.value;
    if (query.value !== '' && query.value.length >= 3) {
        await client.get<SearchGuidesByCategoryResponse>(new SearchGuidesByCategory({
            q: query.value,
            category: 'Shows'}
        ))
            .then(res => {
                shows.value = res.results;
            });
    }
};

const displaySelectedShow = (selectedShow: any) => {
    let display = '';

    if (selectedShow.title) {
        if (selectedShow.category) {
            display = `${selectedShow.title} (${selectedShow.category})`;
        } else {
            display = `${selectedShow.title}`;
        }
    }
    return display;
};

let companies = ref([]);
const selectedCompany = ref({});
const companyQuery = ref('');


const queryCompany = computed(() => {
    return companyQuery.value === '' || companyQuery.value.length < 3 ? null : {id: null, name: companyQuery.value}
});

const getCompanies = async (event: any) => {
    companyQuery.value = event.target.value;
    if (companyQuery.value !== '' && companyQuery.value.length >= 3) {
        await client.get<SearchGuidesByCategoryResponse>(new SearchGuidesByCategory({
            q: companyQuery.value,
            category: 'Companies'
        }))
            .then(res => {
                //companies.value = res.results;
                if(res.results){
                    let results = res.results.map((company: any) => {
                        return {
                            name: company.name,
                            id: company.id,
                            logo: company.logoUrl,
                            address: company.shortAddressPrettified
                        }
                    });
                    _.merge(companies.value, results);   
                }
            });

        await client.get<SearchGuidesByCategoryResponse>(new SearchGuidesByCategory({
            q: companyQuery.value,
            category: 'College Programs'
        }))
            .then(res => {
                if(res.results){
                    let results = res.results.map((program: any) => {
                        return {
                            name: program.programName,
                            id: program.id,
                            logo: program.logoUrl,
                            address: program.displayAddress
                        }
                    });
                    _.merge(companies.value, results);
                }
            });
    }
};

const displaySelectedCompany = (selectedCompany: any) => {
    let display = '';

    if (selectedCompany.name) {
        if (selectedCompany.shortAddressPrettified) {
            display = `${selectedCompany.name} (${selectedCompany.shortAddressPrettified})`;
        } else {
            display = `${selectedCompany.name}`;
        }
    }
    return display;
};


const showTypeOptions = ref([
    'Stage',
    'Television',
    'Film',
    'Modeling',
    'Dance',
    'Voice-Over',
    'Web Series',
    'Other'
]);

onMounted(async () => {
    await getExperiences();
});

const getExperiences = async () => {
    await client.get<GetExperiencesResponse>(new GetExperiences())
        .then(response => {
            credits.value = response.credits;
        });
}

const isSubmitting = ref(false);
const submit = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;
    responseStatus.value = null;

    let request = credit.value;
    if (selectedShow.value && selectedShow.value.title) {
        request.showName = selectedShow.value.title;
        request.showId = selectedShow.value.id;
    } else {
        request.showName = ''
    }
    if (selectedCompany.value && selectedCompany.value.name) {
        request.companyName = selectedCompany.value.name;
        request.companyId = selectedCompany.value.id;
    } else {
        request.companyName = '';
    }
    await client.post<GetExperiencesResponse>(new AddExperience(request))
        .then(async (res) => {
            credit.value = {};
            selectedShow.value = {};
            selectedCompany.value = {};
            updateSuccessful.value = true;
            responseStatus.value = null;
            credits.value = res.credits;

            trackEvent( 'profile_updated', {
                method: 'credit_added'
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};

const toggleIsFeatured = async (credit: ExperienceDTO) => {
    await client.post<ResponseStatus>(new ToggleExperienceIsFeatured({
        id: credit.id,
        isFeatured: !credit.isFeatured
    }))
        .then(async () => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            credit.isFeatured = !credit.isFeatured;
        })
}

const deleteCredit = async (credit: ExperienceDTO) => {
    await client.post<ResponseStatus>(new DeleteExperience({id: credit.id}))
        .then(async () => {
            await getExperiences();
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
}

const sortCredits = async () => {
    let request = {
        ids: credits.value.map((c: ExperienceDTO) => c.id)
    };
    await client.post<ResponseStatus>(new SortExperiences(request))
        .then(async () => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm font-medium text-right text-red-600" }, [
        _createTextVNode(" * "),
        _createElementVNode("span", { class: "text-slate-600" }, " Required field")
      ], -1)),
      _createElementVNode("form", null, [
        _createVNode(ErrorSummary, { "response-status": _unref(responseStatus) }, null, 8, ["response-status"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "selectedShow"
                }, [
                  _createTextVNode("Show/Project "),
                  _createElementVNode("span", { class: "text-red-600" }, "*")
                ], -1)),
                _createVNode(_unref(Combobox), {
                  modelValue: selectedShow.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedShow).value = $event)),
                  as: "div",
                  nullable: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(ComboboxInput), {
                        "display-value": displaySelectedShow,
                        id: "selectedShow",
                        class: "w-full py-2 pl-3 pr-10 bg-white border rounded-md shadow-sm border-clay-500 focus:border-clay-500 focus:outline-hidden focus:ring-1 focus:ring-clay-500 sm:text-sm",
                        onChange: getShows
                      }),
                      _createVNode(_unref(ComboboxButton), {
                        class: "absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md focus:outline-hidden",
                        "aria-label": "Expand Button"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ChevronDownIcon), {
                            "aria-hidden": "true",
                            class: "w-5 h-5 text-gray-400"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ComboboxOptions), { class: "absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm" }, {
                        default: _withCtx(() => [
                          (queryShow.value)
                            ? (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                key: 0,
                                value: queryShow.value,
                                as: "template"
                              }, {
                                default: _withCtx(({ active, selected }) => [
                                  _createElementVNode("li", {
                                    class: _normalizeClass(['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900'])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                    }, " Add \"" + _toDisplayString(query.value) + "\" ", 3),
                                    selected
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass(['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600'])
                                        }, [
                                          _createVNode(_unref(CheckIcon), {
                                            "aria-hidden": "true",
                                            class: "w-5 h-5"
                                          })
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _: 1
                              }, 8, ["value"]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shows), (show) => {
                            return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                              key: show.id,
                              value: show,
                              as: "template"
                            }, {
                              default: _withCtx(({ active, selected }) => [
                                _createElementVNode("li", {
                                  class: _normalizeClass(['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900'])
                                }, [
                                  _createElementVNode("div", _hoisted_7, [
                                    (show.logo)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: show.logo,
                                          class: "w-5 h-5 mr-2 shrink-0"
                                        }, null, 8, _hoisted_8))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                    }, _toDisplayString(show.title) + " (" + _toDisplayString(show.category) + ") ", 3),
                                    selected
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: _normalizeClass(['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600'])
                                        }, [
                                          _createVNode(_unref(CheckIcon), {
                                            "aria-hidden": "true",
                                            class: "w-5 h-5"
                                          })
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "type"
                }, [
                  _createTextVNode("Type "),
                  _createElementVNode("span", { class: "text-red-600" }, "*")
                ], -1)),
                _createVNode(SaCombobox, {
                  id: "type",
                  modelValue: _unref(credit).type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(credit).type) = $event)),
                  options: showTypeOptions.value,
                  name: "type"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "role"
                }, [
                  _createTextVNode("Role "),
                  _createElementVNode("span", { class: "text-red-600" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "role",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(credit).role) = $event)),
                  class: "block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                  name: "role",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _unref(credit).role]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "companyName"
                }, [
                  _createTextVNode("Organization "),
                  _createElementVNode("span", { class: "text-red-600" }, "*")
                ], -1)),
                _createVNode(_unref(Combobox), {
                  modelValue: selectedCompany.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedCompany).value = $event)),
                  as: "div",
                  nullable: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_unref(ComboboxInput), {
                        "display-value": displaySelectedCompany,
                        id: "companyName",
                        class: "w-full py-2 pl-3 pr-10 bg-white border rounded-md shadow-sm border-clay-500 focus:border-clay-500 focus:outline-hidden focus:ring-1 focus:ring-clay-500 sm:text-sm",
                        onChange: getCompanies
                      }),
                      _createVNode(_unref(ComboboxButton), {
                        class: "absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md focus:outline-hidden",
                        "aria-label": "Expand Button"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ChevronDownIcon), {
                            "aria-hidden": "true",
                            class: "w-5 h-5 text-gray-400"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ComboboxOptions), { class: "absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm" }, {
                        default: _withCtx(() => [
                          (queryCompany.value)
                            ? (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                key: 0,
                                value: queryCompany.value,
                                as: "template"
                              }, {
                                default: _withCtx(({ active, selected }) => [
                                  _createElementVNode("li", {
                                    class: _normalizeClass(['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900'])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                    }, " Add \"" + _toDisplayString(companyQuery.value) + "\" ", 3),
                                    selected
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass(['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600'])
                                        }, [
                                          _createVNode(_unref(CheckIcon), {
                                            "aria-hidden": "true",
                                            class: "w-5 h-5"
                                          })
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _: 1
                              }, 8, ["value"]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companies), (company) => {
                            return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                              key: company.id,
                              value: company,
                              as: "template"
                            }, {
                              default: _withCtx(({ active, selected }) => [
                                _createElementVNode("li", {
                                  class: _normalizeClass(['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900'])
                                }, [
                                  _createElementVNode("div", _hoisted_13, [
                                    (company.logo)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: company.logo,
                                          class: "w-5 h-5 mr-2 shrink-0"
                                        }, null, 8, _hoisted_14))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                    }, _toDisplayString(company.name) + " " + _toDisplayString(company.address ? `(${company.address})` :
                                                        ''), 3),
                                    selected
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: _normalizeClass(['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600'])
                                        }, [
                                          _createVNode(_unref(CheckIcon), {
                                            "aria-hidden": "true",
                                            class: "w-5 h-5"
                                          })
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "dateYear"
                }, "Year", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dateYear",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(credit).dateYear) = $event)),
                  class: "block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                  name: "dateYear",
                  type: "number",
                  min: "1950"
                }, null, 512), [
                  [_vModelText, _unref(credit).dateYear]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "director"
                }, "Director", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "director",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(credit).director) = $event)),
                  class: "block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                  name: "director",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _unref(credit).director]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(SaButton, {
                onClick: _withModifiers(submit, ["prevent"]),
                loading: isSubmitting.value,
                variant: "primary"
              }, {
                loading: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" Adding... ")
                ])),
                default: _withCtx(() => [
                  _cache[14] || (_cache[14] = _createTextVNode(" Add "))
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mt-4 space-y-1 sm:mt-10" }, [
        _createElementVNode("h3", { class: "text-xl font-bold leading-6 text-gray-900" }, "Your Credits"),
        _createElementVNode("p", { class: "max-w-2xl text-sm text-clay-800" }, "Drag/drop your credits listed below to adjust the display order on your profile.")
      ], -1)),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_unref(draggable), {
          modelValue: _unref(credits),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(credits) ? (credits).value = $event : credits = $event)),
          options: {handle:'.handle'},
          "item-key": "id",
          onChange: sortCredits
        }, {
          item: _withCtx(({element}) => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_unref(ListBulletIcon), {
                  "aria-hidden": "true",
                  class: "w-5 h-5 text-gray-400 handle"
                })
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(element.showName), 1),
                _createElementVNode("span", _hoisted_24, " (" + _toDisplayString(element.type) + ")", 1),
                (element.dateYear)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, ", " + _toDisplayString(element.dateYear), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, _toDisplayString(element.role), 1),
              _createElementVNode("div", _hoisted_27, [
                _createTextVNode(_toDisplayString(element.organizationName), 1),
                (element.director)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, ", " + _toDisplayString(element.director), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_unref(Switch), {
                  modelValue: element.isFeatured,
                  "onUpdate:modelValue": ($event: any) => ((element.isFeatured) = $event),
                  class: _normalizeClass([element.isFeatured ? 'bg-clay-600' : 'bg-gray-200', 'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500']),
                  onClick: _withModifiers(($event: any) => (toggleIsFeatured(element)), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "sr-only" }, "Feature on profile?", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass([element.isFeatured ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-sm transform ring-0 transition ease-in-out duration-200']),
                      "aria-hidden": "true"
                    }, null, 2)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "class", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("a", {
                  class: "text-xs text-clay-600 hover:text-clay-900",
                  onClick: _withModifiers(($event: any) => (deleteCredit(element)), ["prevent"])
                }, [
                  _createVNode(_unref(TrashIcon), { class: "w-5 h-5 text-red-300 sm:float-right hover:text-red-500" })
                ], 8, _hoisted_31)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: _unref(updateSuccessful),
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})